import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../store'
import { UserData } from '../../models/types'

interface SendActivityEventListenerProps {
  isRetorikNews: boolean
  hasConversationCookie: boolean
  userData: UserData
}

const SendActivityEventListener = ({ isRetorikNews, hasConversationCookie, userData }: SendActivityEventListenerProps): null => {
  const dispatch = useDispatch()
  const displayGDPR = useSelector((state: RootState) => state.utilsReducer.GDPRDisplay)
  const userConsent = useSelector((state: RootState) => state.utilsReducer.GDPRUserConsent)
  const loaderClosed = useSelector((state: RootState) => state.retorikReducer.loaderClosed)
  const appAvailable = useSelector((state: RootState) => state.retorikReducer.appAvailable)
  const skipWelcome = useSelector((state: RootState) => state.retorikReducer.configuration.skipWelcome)
  const userAlreadySet = useSelector((state: RootState) => state.retorikReducer.userAlreadySet)
  const characterLoaded = useSelector((state: RootState) => state.viewReducer.characterLoaded)

  /**
   * Send mandatory events : Davi.GDPRConsent for GDPR module then setUser to start conversation
   */
  const sendMandatoryEvents = async (): Promise<void> => {
    dispatch(
      storeActions.directline.sendEvent({
        name: 'Davi.GDPRConsent',
        value: {
          userConsent: userConsent
        },
        callback: () =>
          dispatch(
            storeActions.directline.sendEvent({
              name: 'setUser',
              value: {
                user: { ...userData, gdprConsent: true },
                skipWelcome: !!skipWelcome
              }
            })
          )
      })
    )
  }

  useEffect(() => {
    if (isRetorikNews || hasConversationCookie) {
      dispatch(storeActions.retorik.setUserAlreadySet(true))
    } else if (!userAlreadySet && appAvailable && !displayGDPR && characterLoaded) {
      dispatch(storeActions.retorik.setUserAlreadySet(true))
      sendMandatoryEvents()
    }
  }, [appAvailable, loaderClosed, displayGDPR, characterLoaded])

  return null
}

export default SendActivityEventListener
